<c11n-card [hasBorder]="true" [density]="cardDensity">
  <div class="beneficiary-card" cardBody>
    <div class="beneficiary-card__name">
      <c11n-dropdown
        *ngIf="dropdownVisible"
        [labelText]="typeConfig.dropdownLabel"
        [menuData]="dropdownData"
        [activeItems]="activeId"
        (stateChange)="handleDropdownChange($event)"
      ></c11n-dropdown>
    </div>

    <div class="beneficiary-card__right-group">
      <div class="beneficiary-card__distribution" *ngIf="dropdownVisible">
        <label
          c11n-label
          [for]="'distribution-' + (beneficiary.householdMemberId || section)"
          [size]="'medium'"
          >{{ content.BENEFICIARY_DISTRIBUTION_LABEL }}</label
        >
        <c11n-input [size]="'medium'">
          <input
            c11nInput
            [id]="'distribution-' + (beneficiary.householdMemberId || section)"
            type="text"
            inputmode="numeric"
            [(ngModel)]="distributionValue"
            [imask]="distributionMask"
            (blur)="handleDistributionChange()"
          />
        </c11n-input>
      </div>

      <!-- Desktop: icon-only buttons -->
      <div class="beneficiary-card__actions beneficiary-card__actions--desktop">
        <c11n-icon-button
          [variant]="'ghost'"
          [size]="'small'"
          [labelText]="'Edit'"
          [iconName]="'edit-user-action'"
          (clickEvent)="handleEditClick()"
        >
        </c11n-icon-button>
        <c11n-icon-button
          [variant]="'ghost'"
          [size]="'small'"
          [labelText]="'Remove'"
          [iconName]="'trash'"
          (clickEvent)="handleRemoveClick()"
        >
        </c11n-icon-button>
      </div>
    </div>

    <!-- Mobile: text links with icons, spread across full width -->
    <div class="beneficiary-card__actions beneficiary-card__actions--mobile">
      <a
        c11n-link
        href="javascript:void(0)"
        [variant]="'secondary-reinforced'"
        [iconName]="'edit-user-action'"
        [iconPosition]="'trailing'"
        (click)="handleEditClick()"
        >Edit</a
      >
      <a
        c11n-link
        href="javascript:void(0)"
        [variant]="'secondary-reinforced'"
        [iconName]="'trash'"
        [iconPosition]="'trailing'"
        (click)="handleRemoveClick()"
        >Remove</a
      >
    </div>
  </div>
</c11n-card>
